import angular from 'angular';
import api from 'auth/resources/forgot-password.api';
import changePasswordTpl from './change-password.html';

const mapStateToThis = ({ session }) => {
  const { locale, tokens } = session;

  return {
    locale,
    tokens,
  };
};

@Inject('$ngRedux', 'gettextCatalog', '$state', 'Notifications')
class ChangePasswordController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onInit() {
    this.formModel = {};
  }

  $onDestroy() {
    this.unsubscribe();
  }

  async changePassword(form) {
    form.$setSubmitted();
    if (form.$invalid) {
      return;
    }
    await api.changePassword(this.formModel.newPasswd, this.tokens.refresh.code);
    await this.Notifications.showAlert(
      this.gettextCatalog.getString('Success!'),
      this.gettextCatalog.getString('Password was reset successfully.')
    ).result;
    await this.api.resetSession.run();
    this.$state.go('home-view', null, { reload: true });
  }
}

class ChangePasswordComponent {
  constructor() {
    this.template = changePasswordTpl;
    this.controller = ChangePasswordController;
    this.bindings = {
      model: '<',
      api: '<',
    };
    return this;
  }
}

export default angular.module('change-password', []).component('changePassword', new ChangePasswordComponent());



// WEBPACK FOOTER //
// ./src/modules/auth/components/change-password/change-password-component.js